import { render, staticRenderFns } from "./home-type1.vue?vue&type=template&id=f0822132&scoped=true"
import script from "./home-type1.vue?vue&type=script&lang=js"
export * from "./home-type1.vue?vue&type=script&lang=js"
import style0 from "./home-type1.vue?vue&type=style&index=0&id=f0822132&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0822132",
  null
  
)

export default component.exports